import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpaceSettingPointRechargeForm(props) {
  return (
    <SpaceRoleRangeForm
      {...props}
      role="point_recharge"
      settingKey="point_recharge_role_setting"
    />
  );
}

export default SpaceSettingPointRechargeForm;
